export const apiName: string = 'bombas';
export const bombasRoute: string = 'bombas';
export const bombasStorage: string = 'bombas';
export const bombasModuleName: any = {plural: 'Bombas', single: 'Bomba'};

export const bombaAuditoriaApiName: string = 'hidrometros';
export const bombasAuditoriaRoute: string = 'auditoria';
export const bombasAuditoriaModuleName: any = {plural: 'Auditorias', single: 'Auditoria'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/shared/data.service.ts
 **/